import { Box, Grid, TextField, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import {
  DEFAULT_LOAN_CONFIG,
  estimateMaxLoanFromCapacityKw,
  pickDefaultLoanAmount,
} from "../../../../infrastructure/utils/loanCalculator";
import LoanRequestSimulator from "../../../components/loan/LoanRequestSimulator";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";

const DEFAULT_CAPACITY_KW = 10;

const LoanSimulatorPage = ({
  title = "شبیه‌ساز درخواست وام",
  subtitle = "با اسکرول مبلغ وام و تعداد اقساط را انتخاب کنید؛ جزئیات بازپرداخت به‌صورت لحظه‌ای محاسبه می‌شود.",
  showCapacityInput = false,
}) => {
  const [capacityKw, setCapacityKw] = useState(DEFAULT_CAPACITY_KW);

  const maxLoanAmount = useMemo(
    () => estimateMaxLoanFromCapacityKw(capacityKw),
    [capacityKw]
  );

  const [loanAmount, setLoanAmount] = useState(() =>
    pickDefaultLoanAmount(
      estimateMaxLoanFromCapacityKw(DEFAULT_CAPACITY_KW),
      DEFAULT_LOAN_CONFIG
    )
  );
  const [installmentCount, setInstallmentCount] = useState(
    DEFAULT_LOAN_CONFIG.defaultInstallments
  );

  useEffect(() => {
    const next = pickDefaultLoanAmount(maxLoanAmount, DEFAULT_LOAN_CONFIG);
    setLoanAmount((prev) => (prev > maxLoanAmount ? next : prev));
  }, [maxLoanAmount]);

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </Grid>

      {showCapacityInput ? (
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <TextField
            fullWidth
            type="number"
            label="ظرفیت نیروگاه (کیلووات)"
            value={capacityKw}
            onChange={(e) => {
              const next = Number(e.target.value);
              setCapacityKw(Number.isFinite(next) && next > 0 ? next : DEFAULT_CAPACITY_KW);
            }}
            inputProps={{ min: 1, step: 0.5 }}
            size="small"
          />
        </Grid>
      ) : null}

      <Grid item xs={12} md={8} lg={5}>
        <Box sx={{ maxWidth: 480, mx: { xs: 0, md: "auto" } }}>
          <LoanRequestSimulator
            maxLoanAmount={maxLoanAmount}
            loanAmount={loanAmount}
            installmentCount={installmentCount}
            onLoanAmountChange={setLoanAmount}
            onInstallmentCountChange={setInstallmentCount}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default LoanSimulatorPage;
